const theadCriteria = [
  { name: "Nit", order: "null" },
  { name: "Zona Franca", order: "null" },
  { name: "Usuario", order: "null" },
  { name: "Criterio", order: "null" },
  { name: "Calificación", order: "null" }
];

export { theadCriteria };
